<script setup>
import { ref, watch } from 'vue'
import { useStatsStore } from '@/store/stats'
import { useRoute } from 'vue-router'
import ApiConsumptions from './charts/ApiConsumptions.vue'
import HealthSystemMonitoring from './charts/HealthSystemMonitoring.vue'
import SystemHealth from './charts/SystemHealth.vue'
import TopTen from './charts/TopTen.vue'
import TotalRows from './charts/TotalRows.vue'
import SyncOperations from './charts/SyncOperations.vue'

const statsStore = useStatsStore()
const route = useRoute()
const loading = ref(true)

const fetchData = async () => {
  loading.value = true
  await Promise.all([
    statsStore.fetchApiConsumptions(),
    statsStore.fetchDashboardStats(),
    statsStore.fetchAnomalies(),
    statsStore.initializeSystemStats()
  ])
  loading.value = false
}

watch(() => route, fetchData, { immediate: true })

const onChangedTimeFrameTotalRows = async (timeFrame) => {
  if (timeFrame) {
    statsStore.syncStatsTotalRows = {}
    statsStore.syncStatsTotalRows = await statsStore.fetchSyncStats(timeFrame)
  }
}

const onChangedTimeFrameOperations = async (timeFrame) => {
  if (timeFrame) {
    statsStore.syncStatsOperations = {}
    statsStore.syncStatsOperations = await statsStore.fetchSyncStats(timeFrame)
  }
}

</script>

<template>
  <div class="flex flex-col gap-4 mx-4 md:mx-0">
    <div class="flex flex-col md:flex-row gap-4 flex-shrink-0 mt-4 md:mt-0">
      <div class="card md:rounded-md rounded-2xl">
        <HealthSystemMonitoring
          v-model="statsStore.healthSystemMonitoring"
        />
      </div>
      <div class="hidden lg:block">
        <div class="card-no-grow flex-shrink-0 relative h-28 md:rounded-md rounded-2xl">
          <div class="flex-1">
            <h1 class="font-semibold leading-none pb-2">
              SyncFDY API
            </h1>
            <div class="pt-2 text-center">
              <Button
                as="a"
                label="Open Playground"
                icon="pi pi-external-link"
                severity="primary"
                href="/api-docs"
                target="_blank"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card md:rounded-md rounded-2xl">
      <SystemHealth :model-value="loading ? [] : statsStore.systemHealth" />
    </div>
    <div class="card md:rounded-md rounded-2xl">
      <ApiConsumptions :model-value="loading ? [] : statsStore.apiConsumptions" />
    </div>
    <div class="flex flex-col lg:flex-row gap-4 w-full dark:border-t-0 border-t-0 dark:border-t-gray-600">
      <div
        class="card-no-grow lg:w-[30rem] w-full md:rounded-md rounded-2xl flex flex-col"
      >
        <TopTen :model-value="loading ? [] : statsStore.dashboardStats.tableRows" />
      </div>
      <div class="card flex-grow min-w-0 md:rounded-md rounded-2xl">
        <TotalRows
          v-model="statsStore.syncStatsTotalRows"
          :objects="statsStore.availableSyncStatsObjects"
          :rows="statsStore.dashboardStats.tableRows"
          @change-time-frame="onChangedTimeFrameTotalRows"
        />
      </div>
    </div>
    <div class="flex flex-row lg:flex-row gap-4 w-full mb-4 dark:border-t-0 border-t-0 dark:border-t-gray-600">
      <div class="card flex-grow min-w-0 md:rounded-md rounded-2xl">
        <SyncOperations
          :model-value="loading ? [] : statsStore.syncStatsOperations"
          :objects="statsStore.availableSyncStatsObjects"
          :rows="statsStore.dashboardStats.tableRows"
          @change-time-frame="onChangedTimeFrameOperations"
        />
      </div>
    </div>
  </div>
</template>
